import { InvoicesApiPreviewInvoiceIdRequest } from '@melio/platform-api-axios-client';
import { useQuery } from 'react-query';

import { getInvoicePreviewPDF } from './utils';

export const useInvoicePreviewPDF = (requestParams: InvoicesApiPreviewInvoiceIdRequest) => {
  const { error, ...rest } = useQuery(['invoicePreviewPDF', requestParams], () => getInvoicePreviewPDF(requestParams));
  return { error: error as PlatformError<string> | undefined, ...rest };
};
